import { Editor } from '@hugerte/hugerte-react';

import { classNames } from 'primereact/utils';
import PropTypes from 'prop-types';

export default function RichTextViewer({
  value,
  disabled,
}) {
  return (
    <Editor
      value={value}
      disabled
      className={classNames('relative', 'custom-tooltip-for-editor-input', {
        'surface-200': disabled,
      })}
      init={{
        branding: false,
        menubar: false,
        toolbar: false,
        statusbar: false,
        plugins: 'autoresize',
        autoresize_bottom_margin: 20,
        content_style: 'p { margin: 0; }',
        init_instance_callback(editor) {
          editor.execCommand('mceAutoResize');
        },
        extended_valid_elements: '+math[*],mrow[*],mo[*],mi[*],mn[*],msup[*],mfrac[*],msqrt[*],mroot[*],mtext[*],mstyle[*],mtable[*],mtr[*],mtd[*],span[*]',
      }}
    />
  );
}

RichTextViewer.propTypes = {
  value: PropTypes.string,
  disabled: PropTypes.bool,
};

RichTextViewer.defaultProps = {
  value: '',
  disabled: false,
};
